import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { breakpoints, Spacings } from '@styles/index';
import Header from './Header';
import AppContainer from '../Components/AppContainer';
import LayoutContainer from '../Components/Container';

const PhysicalNotesContentContainer = styled(AppContainer)`
  min-height: calc(100vh - 56px);
  grid-auto-rows: max-content;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    width: 768px;
    padding: 0 ${Spacings.SPACING_5B};
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    padding: 0 ${Spacings.SPACING_4B};
    grid-template-columns: repeat(8, 1fr);
    grid-column-gap: ${Spacings.SPACING_2B};
    margin-top: ${Spacings.SPACING_4B};
    grid-row-gap: ${Spacings.SPACING_2B};
  }
`;

const PhysicalNotesLayout = ({ children, className }) => {
  return (
    <LayoutContainer className={className}>
      <Header />
      <PhysicalNotesContentContainer className="container">
        {children}
      </PhysicalNotesContentContainer>
    </LayoutContainer>
  );
};

PhysicalNotesLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  className: PropTypes.string
};

PhysicalNotesLayout.defaultProps = {
  className: ''
};

export default PhysicalNotesLayout;
